import React, {useEffect} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFreezeCardMutation} from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";

const FreezeCardModal = ({showFreezeCardModal, onHide, details, tableRef}) => {
    const [
        freezeCard, // This is the mutation trigger
        {
            isLoading: isFreezing,
            isSuccess: frozenSuccessfully,
        }, // This is the destructured mutation result
    ] = useFreezeCardMutation()

    /* Close Modal on Successful Freeze */
    useEffect(() => {
        if (frozenSuccessfully) {
            cogoToast.success("Created 'Freeze Card' action successfully")
            tableRef.current.refresh()
            onHide()
        }
    }, [frozenSuccessfully]);

    /* Freeze Card */
    const onSubmit = e => {
        e.preventDefault();
        e.stopPropagation();

        freezeCard({
            userId: details?.userId,
            cardId: details?.id,
            cardName: details?.cardName,
            meta: details,
        })
    }

    return (
        <Modal
            show={showFreezeCardModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isFreezing ? "static" : true}
            keyboard={!isFreezing}
        >
            <Form
                noValidate
                onSubmit={onSubmit}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Freeze Card
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>

                <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                    <p>{`Are you sure you want to freeze ${details?.cardName}?`}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={onHide}
                        disabled={isFreezing}
                        className="btn btn-light btn-elevate px-4"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={isFreezing}
                        className="btn btn-primary btn-elevate px-4 ml-4"
                    >
                        Freeze
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default FreezeCardModal;
